import { gql } from '@apollo/client';

const EmployeeFragment = gql`
  fragment Employee on Employee {
    id

    name
    role
  }
`;

export default EmployeeFragment;
